import { useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import Box from '@mui/system/Box';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, useWatch } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { getVerificationMonthData } from '../../redux/verification/verificationGetMonth';
import BackIcon from '../common/Back/BackIcon';
import FormInputDropdown from '../common/Forms/FormDropdown';
import FormInputText from '../common/Forms/FormTextField';
import PageHeading from '../common/Heading/PageHeading';
import { GridContainer, LeftGrid } from '../Episode/Episode.Styled';
import { ContentTitle } from '../ui/styled';
import VerificationTreatment from './VerificationTreatment';
import { Auth } from 'aws-amplify';
import { useDebouncedCallback } from 'use-debounce';
import {
  dateFormat,
  dateFormatWeek,
  emptyMonth,
  formDateFormat,
  VERIFICATION_BASE_URL,
  VERIFICATION_INSERT
} from '../../constants';
import moment from 'moment';
import {
  setCbpProvider,
  setMonth,
  setNewVerificationForm,
  setSearchCbp,
  setStartingMonday,
} from '../../redux/verification/VerificationSlice';
import { getVerifySliceForm } from '../../redux/verification/VerifySliceForm';
import VarificationPopUp from '../common/VarificationPopup/VarificationPopup';
import { getStopApi, setStopApi, postStopApi } from '../../services/StopApi/StopApi';
import { setIsCallVerifyPopup } from '../../redux/verification/verificationDialogPopupData';
import VarificationNewPopUp from '../common/VarificationPopup/verificationNewPopup';
import VarificationRatesPopUp from '../common/VarificationPopup/VerificationRatesPopup';
import VerificationReceivedPopUp from '../common/VarificationPopup/VerificationReceivedPopUp';
import VarificationCbpRatesPopUp from '../common/VarificationPopup/VarificationCbpRates';
import {
  verificationsList,
} from '../../redux/verification/VerificationSlice';

const VerificationDetails = () => {
  //console.log('load component')
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [cancelButton, setCancelButton] = useState(true);  
  const [varificationPopUp, setVarificationPopUp] = useState(false);
  const [varificationMessage, setVarificationMessage] = useState('');
  const [varificationNewPopUp, setVarificationNewPopUp] = useState(false);
  const [varificationNewMessage, setVarificationNewMessage] = useState('');
  const [varificationRatesPopUp, setVarificationRatesPopUp] = useState(false);
  const [varificationRatesMessage, setVarificationRatesMessage] = useState('');
  const [varificationCbpRatesPopUp, setVarificationCbpRatesPopUp] = useState(false);
  const [varificationCbpRatesMessage, setVarificationCbpRatesMessage] = useState('');
  const [latestCbpProvider, setLatestCbpProvider] = useState('');
  const [varificationListDataUpdate, setVarificationListDataUpdate] = useState('');
  
  const verificationReferenceData = useSelector((state) => state.verificationReferenceData);
  const VerificationDialogPopup = useSelector((state) => state.VerificationDialogPopupSlice?.VerificationDialogPopup);
  const verificationListData = useSelector((state) => state?.verificationListSlice);
  //console.log('### verificationReferenceData')
  //console.log(verificationReferenceData)
  //console.log('### verificationListData')
  //console.log(verificationListData)

  var currentMonday = new Date();
  currentMonday.setHours(0,0,0,0);
  while (currentMonday.getDay() !== 1)
    currentMonday.setDate(currentMonday.getDate() - 1);
  const formattedMonday = moment(currentMonday).format(formDateFormat);
  console.log(formattedMonday);
  //verificationListData.startingMonday = {'id': formattedMonday, 'value': formattedMonday}
  


  //if (id==0) {
  //  let clone = structuredClone(verificationListData);
  //  clone.month = {id: '', value: ''};
  //  clone.cbpId = '';
  //  clone.month = '';
  //  clone.provider = {cbpId: '', name: ''};
  //  clone.startingMonday = {id: '', value: ''};
  //  clone.week = '';
  //  dispatch(verificationsList(clone));  
  //}

  const [verificationReceivedPopUp, setVerificationReceivedPopUp] = useState(false);
  const [verificationReceived, setVerificationReceived] = useState(false);
  const [createVerification, setCreateVerification] = useState(false);

  const monthData = useSelector((state) => state.verificationMonthData);
  //console.log('### MONTH DATE')
  //console.log(monthData)
  let verifyMasterReferenceData = useSelector((state) => state.verifyMasterReferenceData);

  //let verifyMasterReferenceData = verifyMasterReferenceDataT; 
  //const verifyMasterReferenceData = verifyMasterReferenceDataT.cbpTreatmentProvider.sort((a, b) => a < b);

  //const MonthSplit =
  //  verificationListData?.startingMonday?.value === undefined
  //    ? ''
  //    : verificationListData?.startingMonday?.value.split('-');
  //const monthJoin =
  //  MonthSplit === undefined ? '' : `${MonthSplit[0]}-${MonthSplit[1]}`;
  //const monthNewDate =
  //  monthDate?.value === ''
  //    ? ''
  //    : monthDate?.filter((item) => (item.value == monthJoin ? item.id : ''));
  const newWeekDate = new Date(verificationListData?.startingMonday?.value);
  const endDateOfWeek = newWeekDate.setDate(newWeekDate.getDate() + 7);
  const sundayDate = moment(endDateOfWeek).format(formDateFormat);
  const cbpData = verifyMasterReferenceData?.cbpTreatmentProvider.find((item) =>
    item.id == verificationListData?.searchCbp ? item.id : ''
  );
  //console.log('### MONTH NEW DATE')
  //console.log(monthNewDate)

  const monday = verificationListData?.startingMonday?.value ? verificationListData?.startingMonday?.value : formattedMonday;
    
  //console.log('verificationListData?.Month?.value ? verificationListData?.Month?.value');
  //console.log(verificationListData?.Month?.value);

  const defaultValue = {
    //startingMonday: verificationListData?.startingMonday?.value,
    startingMonday: monday,
    //startingMconstonday: formattedMonday,
    month: verificationListData?.Month?.value,
    cbpID: verificationListData?.provider?.cbpId
      ? verificationListData?.provider?.cbpId
      : verificationListData?.searchCbp,
    cbpProvider: verificationListData?.provider?.name,
    startDate: verificationListData?.startingMonday?.value,
    endDate: sundayDate,
  };

  console.log('### defaultValue')
  console.log(defaultValue)

  //console.log(verificationListData);

  //const defaultValue = {
  //  startingMonday: id == 0 ? '' : verificationListData?.startingMonday?.value,
  //  month: id == 0 ? '' : verificationListData?.Month?.value,
  //  cbpID: id == 0 ? '' : verificationListData?.provider?.cbpId
  //    ? verificationListData?.provider?.cbpId
  //    : verificationListData?.searchCbp,
  //  cbpProvider: id == 0 ? '' : verificationListData?.provider?.name,
  //  startDate: verificationListData?.startingMonday?.value,
  //  endDate: sundayDate,
  //};

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { handleSubmit, reset, control, setValue, watch, register } =
    useFunction;

  const startingMonday = useWatch({
    control,
    name: 'startingMonday',
  });
  const startingMondayIds = verificationReferenceData?.weeks?.filter((item) =>
    item.value.split('T')[0] === startingMonday ? item.value : ''
  );

  const startingMondayValues = {
    id: startingMondayIds ? startingMondayIds[0]?.id.split('T')[0] : '',
    value: startingMondayIds ? startingMondayIds[0]?.value.split('T')[0] : '',
  };

  const month = useWatch({
    control,
    name: 'month',
  });
  //console.log('### month')
  //console.log(month)

  const monthIds = !Array.isArray(monthData) ? [{id: '', value: ''}] : monthData?.filter((item) =>
     item.value === month ? item.value : ''
  );
  //console.log('### monthIds')
  //console.log(monthIds)

  const monthValues = {
     id: monthIds[0]?.id,
     value: monthIds[0]?.value,
  };
  //console.log('### monthValues')
  //console.log(monthValues)

  const cbpProvider = useWatch({
    control,
    name: 'cbpProvider',
  });
  const cbpProviderIds = verificationReferenceData?.providers?.filter((item) =>
    item.value === cbpProvider ? item.id : ''
  );

  const cbpIDValue = useWatch({
    control,
    name: 'cbpID',
  });

  const cbpSearchProviders = {
    cbpId: cbpData?.id ? cbpData?.id : '',
    name: cbpData?.value ? cbpData?.value : '',
  };

  const cbpProviderValues = {
    cbpId: cbpProviderIds ? cbpProviderIds[0]?.id : '',
    name: cbpProviderIds ? cbpProviderIds[0]?.value : '',
  };

  const mondayMonth = startingMonday?.replace('T', ` `);
  
  //useEffect(() => {
  //  if (user?.signInUserSession.accessToken.jwtToken) {
  //    handelResetClick();
  //  }
  //  getUser().then((userData) => setUser(userData));
  //}, [
  //  user?.signInUserSession.accessToken.jwtToken,
  //  defaultValue.cbpID,
  //  defaultValue.startingMonday,
  //  defaultValue.startDate,
  //  defaultValue.Month,
  //]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      if (id != 0) {
        handelResetClick();
        if (mondayMonth) {
          FetchMonth();
        }
      }
    }
    getUser().then((userData) => setUser(userData));    
    //dispatch(setStartingMonday(startingMondayValues));
    //dispatch(setMonth(monthValues));
    //if (latestCbpProvider === 'cbpProvider') {
    //  dispatch(setCbpProvider(cbpProviderValues));
    //} else if (latestCbpProvider === 'cbpID') {
    //  dispatch(setCbpProvider(cbpSearchProviders));
    //}
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    //startingMonday,
    //month,
    //cbpProvider,
    //cbpIDValue,
    //verificationListData?.searchCbp,
  ]);

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      if (mondayMonth) {
        FetchMonth();
      }
    }
    dispatch(setStartingMonday(startingMondayValues));
  }, [startingMonday  
  ]);

  useEffect(() => {
    dispatch(setMonth(monthValues));
  }, [month
  ]);

  useEffect(() => {
    if (latestCbpProvider === 'cbpProvider') {
      dispatch(setCbpProvider(cbpProviderValues));
    } else if (latestCbpProvider === 'cbpID') {
      dispatch(setCbpProvider(cbpSearchProviders));
    }
  }, [cbpProvider
  ]);

  useEffect(() => {
    if (latestCbpProvider === 'cbpProvider') {
      dispatch(setCbpProvider(cbpProviderValues));
    } else if (latestCbpProvider === 'cbpID') {
      dispatch(setCbpProvider(cbpSearchProviders));
    }
  }, [cbpIDValue
  ]);

  const FetchMonth = async () => {
    const url = `${VERIFICATION_BASE_URL}/Months/${mondayMonth}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getVerificationMonthData({ url, authorization }));
  };



  useEffect(() => {
    //if (id != 0) {
      //console.log('reset values on any')
      //console.log('reset with')
      //console.log(defaultValue)
      reset(defaultValue);
    //}  
  }, [
    defaultValue.cbpID,
    defaultValue.cbpProvider,
    defaultValue.endDate,
    defaultValue.Month,
    defaultValue.startingMonday,
  ]);

  //useEffect(() => {
  //  if (user?.signInUserSession.accessToken.jwtToken) {
  //    if (
  //      defaultValue.startingMonday &&
  //      defaultValue.Month &&
  //      defaultValue.cbpID
  //    ) {
  //      handelResetClick();
  //    }
  //  }
  //}, [
  //  defaultValue.cbpID,
  //  defaultValue.startDate,
  //  defaultValue.startingMonday,
  //  defaultValue.Month,
  //]);

  //useEffect(() => {
  //  if (id==0) {
  //    console.log('reset values on id=0')
  //    console.log('reset with')
  //    console.log(defaultValue)
  //    //defaultValue.startingMonday='';
  //    //dispatch(setStartingMonday({id: '', value: ''}));
  //    //defaultValue.month='';
  //    defaultValue.cbpID='';
  //    defaultValue.cbpProvider='';
  //    //defaultValue.startDate='';
  //    //defaultValue.endDate='';
  //    reset(defaultValue);
  //    setCancelButton(true);
  //  }  
  //}, [
  //  id
  //]);

  const handelCancel = () => {

    const url = `${VERIFICATION_BASE_URL}/resetLock`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const payload = {
      cboId: defaultValue.cbpID,
      lockYn: false,
      verWkId: defaultValue.startDate,
    };
    setStopApi({ url, payload, authorization }).then((response) => {
      //if (response.succeeded === true) {
      //  fetchVerify();
      //}
    }).catch((e) => alert(e));

    setCancelButton(true);
  };

  const handleVerify = () => {
    markReceived(true);
    handelCancel();
    navigate(-1);
  };

  const handleRelease = () => {
    markReceived(false);
    handelCancel();
    navigate(-1);
  };

  const markReceived = (status) => {
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    if (createVerification) {
      const url = `${VERIFICATION_INSERT}?WkID=${defaultValue.startDate}&MthID=${defaultValue.month}&CboID=${defaultValue.cbpID}`;
        postStopApi({
          url,
          'payload': '',
          authorization,
      }).then((response) => {
        fetchVerify();
      }).catch((e) => {
        console.log(e);
        alert(e);
      });
    }
    else {
      const url = `${VERIFICATION_BASE_URL}/received/${status}`;      
      const payload = {
        cboId: defaultValue.cbpID,
        verMthId: defaultValue.month,
        verWkId: defaultValue.startDate,
      };
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchVerify();
        }
      }).catch((e) => alert(e));
    }  
  };

  const handelResetClick = () => {
    const url = `${VERIFICATION_BASE_URL}/resetLock`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const payload = {
      cboId: defaultValue.cbpID,
      lockYn: false,
      verWkId: defaultValue.startDate,
    };
    setStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        fetchVerify();
      }
    }).catch((e) => alert(e));
  };


  const fetchVerify = async () => {
    //console.log('### fetchVerify cbpIDValue');
    //console.log(cbpIDValue);
    //console.log('### fetchVerify startingMonday');
    //console.log(startingMonday);
    //console.log('### fetchVerify monthIds');
    //console.log(monthIds);
    //console.log('### fetchVerify month');
    //console.log(month);
    //alert(monthIds.length)
    if (cbpIDValue && startingMonday && month) {
      const commonParams = `${VERIFICATION_BASE_URL}/verify/${cbpIDValue}/${startingMonday}/${month}`;
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      getStopApi({ commonParams, authorization }).then((response) => {
        const verifyForm = response?.data;
        console.log('### verifyForm')
        console.log(verifyForm)
        setVarificationListDataUpdate(verifyForm);
        setCancelButton(false);
        
        //setVerificationReceivedPopUp(!verifyForm?.verificationModelList?.verificationDataModelList[0]?.verRecYn);
        setVerificationReceived(verifyForm?.verificationModelList?.verificationDataModelList.length > 0 ? verifyForm?.verificationModelList?.verificationDataModelList[0]?.verRecYn : false);
        setCreateVerification(verifyForm?.verificationModelList?.verificationDataModelList.length == 0)
        if (verifyForm?.verificationModelList?.errorMessage !== '' ) {
          if (VerificationDialogPopup?.isCallVerifyPopup === false) {
            setVarificationNewPopUp(true);
            setVarificationNewMessage(
              verifyForm?.verificationModelList?.errorMessage
            );
          }
          //dispatch(setIsCallVerifyPopup(false));
          //handelCancel();
        }
        if (verifyForm?.cbpRatesCount?.errorMessage !== '') {
          if (VerificationDialogPopup?.isCallVerifyPopup === false) {
            setVarificationCbpRatesPopUp(true);
            setVarificationCbpRatesMessage(
              verifyForm?.cbpRatesCount?.errorMessage
            );
          }
          dispatch(setIsCallVerifyPopup(false));
          handelCancel();
        }
        if (
          verifyForm?.isCBPActive &&
          verifyForm?.isCBPActive?.errorMessage !== ''
        ) {
          if (VerificationDialogPopup?.isCallVerifyPopup === false) {
            setVarificationRatesPopUp(true);
            setVarificationRatesMessage(verifyForm?.isCBPActive?.errorMessage);
          }
          dispatch(setIsCallVerifyPopup(false));
          handelCancel();
        }
        if (verifyForm?.verifyDataCreationErrorMessage && verifyForm?.verifyDataCreationErrorMessage !== '' && verifyForm?.verifyDataCreationErrorMessage !== 'Success') {
          //console.log('### VerificationDialogPopup?.isCallVerifyPopup');
          //console.log(VerificationDialogPopup?.isCallVerifyPopup);
          if (!VerificationDialogPopup?.isCallVerifyPopup) {
            //if (verifyForm?.verifyDataCreationErrorMessage !== 'Success')
            //  setCancelButton(true);
            setVarificationPopUp(true);
            setVarificationMessage(verifyForm?.verifyDataCreationErrorMessage);
          }
          dispatch(setIsCallVerifyPopup(false));
          handelCancel();
        } 
        //else if (verifyForm?.verificationModelList?.verificationDataModelList !== '') 
        //{
        //  if (verifyForm?.verificationModelList?.verificationDataModelList[0]?.verRecYn == false)
        //  {
        //    fetchUpadateVerification();
        //  }
        //}
      }).catch((e) => alert(e));
    }  
  };

  const handleSearchText = useDebouncedCallback((e) => {
    dispatch(setSearchCbp(e.target.value));
  }, 1500);

  return (
    <>
      <ContentTitle container>
        <BackIcon level={id==0 ? -3 : -1} />
        <PageHeading title='Verification Details' />
      </ContentTitle>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <FormInputDropdown
            name='startingMonday'
            control={control}
            label='Starting Monday'
            options={verificationReferenceData?.weeks}
            isWeeks={true}
            disabled={
              varificationListDataUpdate?.verificationDataList != ''
                ? cancelButton == true
                  ? false
                  : verificationListData?.startingMonday?.value === undefined ||
                    verificationListData?.provider?.cbpId === '' ||
                    verificationListData?.provider?.name === ''
                  ? false
                  : true
                : false
            }
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputDropdown
            name='month'
            control={control}
            label='Month'
            options={monthData?.value === '' ? emptyMonth : monthData}
            disabled={
              varificationListDataUpdate?.verificationDataList != ''
                ? cancelButton == true
                  ? false
                  : verificationListData?.startingMonday?.value === undefined ||
                    verificationListData?.provider?.cbpId === '' ||
                    verificationListData?.provider?.name === ''
                  ? false
                  : true
                : false
            }
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputDropdown
            name='cbpProvider'
            control={control}
            label='CBP (Treatment Provider)'
            options={verifyMasterReferenceData?.cbpTreatmentProvider}
            provider={true}
            disabled={
              varificationListDataUpdate?.verificationDataList != ''
                ? cancelButton == true
                  ? false
                  : verificationListData?.startingMonday?.value === undefined ||
                    verificationListData?.provider?.cbpId === '' ||
                    verificationListData?.provider?.name === ''
                  ? false
                  : true
                : false
            }
            register={register('cbpProvider', {
              onChange: (e) => {
                setLatestCbpProvider('cbpProvider');
              },
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name='cbpID'
            control={control}
            label='CBP ID'
            disabled={
              varificationListDataUpdate?.verificationDataList != ''
                ? cancelButton == true
                  ? false
                  : verificationListData?.startingMonday?.value === undefined ||
                    verificationListData?.provider?.cbpId === '' ||
                    verificationListData?.provider?.name === ''
                  ? false
                  : true
                : false
            }
            register={register('cbpID', {
              onChange: (e) => {
                setLatestCbpProvider('cbpID');
                handleSearchText(e);
              },
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='startDate'
            control={control}
            type='date'
            label='Start Date'
            disabled={true}
            shrink={true}
            // register={register('DOB', {
            //   onChange: (e) => dispatch(setDOB(e.target.value)),
            // })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name='endDate'
            control={control}
            type='date'
            label='End Date'
            disabled={true}
            shrink={true}
            // register={register('DOB'
            //   onChange: (e) => dispatch(setDOB(e.target.va, {lue)),
            // })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
        </Grid>
      </Grid>
      <Grid container style={{ justifyContent: 'flex-end' }}>
        {/* <Button
          disabled={verifyFormData?.verificationDataList == '' ? true : false}
          style={{ marginRight: '10px' }}
          variant='contained'
        >
          Verify
        </Button> */}
        {/**
        <Button
          style={{ marginRight: '10px' }}
          disabled={cancelButton == true ? false : true}
          variant='contained'
        >
          Feedback
        </Button>
        <Button style={{ marginRight: '10px' }} variant='contained'>
          Email CBP
        </Button>
        **/}
        <Button
          style={{ marginRight: '10px' }}
          variant='contained'
          onClick={handelResetClick}
          disabled={cbpProviderIds?.length>0 && monthIds?.length>0 && cancelButton == true ? false : true}
        >
          Search
        </Button>
        <Button
          style={{ marginRight: '10px' }}
          variant='contained'
          onClick={handelCancel}
          disabled={cancelButton == true ? true : false}
        >
          Cancel
        </Button>
      </Grid>
      <Box style={{ marginTop: '20px' }}>
        {(varificationListDataUpdate?.verificationDataList === '' &&
          verificationListData?.startingMonday?.value === undefined) ||
        verificationListData?.provider?.cbpId === '' ||
        verificationListData?.provider?.name === '' ? (
          <> </>
        ) : (
          <>
            {cancelButton == true ? (
              <></>
            ) : (
              <>
                {varificationListDataUpdate?.verificationDataList != '' && (
                  <VerificationTreatment
                    verificationDataList={
                      varificationListDataUpdate?.verificationDataList
                    }
                    authToken={user?.signInUserSession?.accessToken?.jwtToken}
                    verifyModelList={
                      varificationListDataUpdate?.verificationModelList
                    }
                    monday={defaultValue.startingMonday}
                    month={defaultValue.month}
                    cbpValue={defaultValue.cbpID}
                    sunday={sundayDate}
                    fetchVerify={handelResetClick}
                    canDisplayGroup={
                      varificationListDataUpdate?.canDisplayGroup
                    }
                  />
                )}
                <Grid container style={{ justifyContent: 'flex-end' }}>
                  { (verificationReceived || createVerification) &&
                    <Button
                      style={{marginTop: '10px', marginRight: '10px' }}
                      variant='contained'
                      onClick={handleRelease}
                    >
                      Release to Provider
                    </Button>
                  }
                  { (!verificationReceived && !createVerification )&&
                    <Button
                      style={{marginTop: '10px', marginRight: '10px' }}
                      variant='contained'
                      onClick={handleVerify}
                    >
                      Verify
                    </Button>
                  }
                </Grid>  
              </>
            )}
          </>
        )}
      </Box>
      <VarificationPopUp
        setVarificationPopUp={setVarificationPopUp}
        varificationPopUp={varificationPopUp}
        message={varificationMessage}
        setVarificationMessage={setVarificationMessage}
      />
      <VarificationNewPopUp
        setVarificationNewPopUp={setVarificationNewPopUp}
        varificationPopUp={varificationNewPopUp}
        message={varificationNewMessage}
        setVarificationNewMessage={setVarificationNewMessage}
      />
      <VarificationRatesPopUp
        setVarificationRatesPopUp={setVarificationRatesPopUp}
        setVarificationRatesMessage={setVarificationRatesMessage}
        varificationRatesPopUp={varificationRatesPopUp}
        message={varificationRatesMessage}
      />
      <VerificationReceivedPopUp
        setVerificationReceivedPopUp={setVerificationReceivedPopUp}
        verificationReceivedPopUp={verificationReceivedPopUp}
        week={verificationListData.week}
        month={verificationListData.month}
        markReceived={markReceived}
      />
      <VarificationCbpRatesPopUp
        setVarificationcbpRatesPopUp={setVarificationCbpRatesPopUp}
        setVarificationCbpRatesMessage={setVarificationCbpRatesMessage}
        varificationCbpRatesPopUp={varificationCbpRatesPopUp}
        message={varificationCbpRatesMessage}
      />
    </>
  );
};

export default VerificationDetails;
